import type { AgentCapabilityMention } from 'shared';

export function capabilityMentionRanges(
  content: string,
  capabilities: AgentCapabilityMention[] = [],
) {
  const ranges = [];
  const pattern =
    /```[\s\S]*?(?:```|$)|`[^`\n]*`|(?:^|[\s（(，,。；;！!？?：:])\$(skill|mcp):("(?:\\.|[^"\\])*"|[\p{L}\p{N}_.-]+)(?=$|[\s）)\]，,。；;！!？?：:])/gu;
  for (const match of content.matchAll(pattern)) {
    if (!match[1]) continue;
    const from = match.index! + match[0].indexOf('$');
    const reference = content.slice(from, match.index! + match[0].length);
    let name = match[2];
    if (name.startsWith('"')) {
      try {
        name = JSON.parse(name) as string;
      } catch {
        continue;
      }
    }
    ranges.push({
      from,
      to: from + reference.length,
      reference,
      type: match[1] as 'skill' | 'mcp',
      name:
        capabilities.find((item) => item.reference === reference)?.name ??
        (/^(?:[\da-f]{24}|[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12})$/i.test(name)
          ? match[1] === 'skill'
            ? 'Skill'
            : 'MCP'
          : name),
    });
  }
  return ranges;
}

export function capabilityMessageContent(
  content: string,
  capabilities: AgentCapabilityMention[] = [],
  markdown = false,
) {
  let result = '';
  let cursor = 0;
  for (const mention of capabilityMentionRanges(content, capabilities)) {
    // 展示名作为文字进入 Markdown，不能把名称中的标记变成链接或其他格式。
    const name = markdown
      ? mention.name.replace(/[\\`*_{}\[\]<>()#+.!|~-]/g, '\\$&')
      : mention.name;
    result += content.slice(cursor, mention.from) + name;
    cursor = mention.to;
  }
  return result + content.slice(cursor);
}

export function capabilityQuery(content: string, caret: number) {
  const before = content.slice(0, caret);
  const match = /(?:^|[\s（(，,。；;！!？?：:])\$([^\s$]*)$/u.exec(before);
  if (!match) return null;
  return { start: caret - match[1].length - 1, end: caret, query: match[1] };
}

export function insertCapabilityReference(
  content: string,
  range: { start: number; end: number },
  reference: string,
) {
  const suffix = content.slice(range.end);
  const prefix = content.slice(0, range.start);
  const inserted = `${prefix && !/[\s（(，,。；;！!？?：:]$/u.test(prefix) ? ' ' : ''}${reference}${/^\s/.test(suffix) ? '' : ' '}`;
  return { content: prefix + inserted + suffix, caret: range.start + inserted.length };
}
